import type { ReactNode } from 'react';
import { Delayed } from './motion';

/** 12px rotating accent spinner (replaces the blinking caret bar everywhere a turn is in progress). */
export function Spinner({ className = '' }: { className?: string }) {
  return <span aria-hidden="true" className={`inline-block h-3 w-3 shrink-0 animate-pc-spin rounded-full border-[1.5px] border-accent border-t-transparent align-[-2px] ${className}`} />;
}

/** Spinner + short mono label ("Thinking…", "Writing in Excel · 12 of 29 · C-Assets"), then `trailing`: the
 *  turn's clock (`TurnClock`), right after what the agent is doing, as a chat or a terminal agent shows it. Fades in
 *  after a short delay (motion.ts ACTIVITY_DELAY_MS) so it does not flash between fast events. */
export function ActivityLine({ label, trailing, delay }: { label: string; trailing?: ReactNode; /** Override of the fade-in delay. */ delay?: number }) {
  return (
    <div className="flex h-[22px] items-center gap-2 font-mono text-[11px] text-muted" role="status">
      <Delayed className="inline-flex items-center gap-2" delay={delay}>
        <Spinner />
        <span>{label}</span>
        {trailing}
      </Delayed>
    </div>
  );
}
